import { BaseHeader } from "customer/BaseHeader";
import React from "react";

export interface BaseLayoutProps {
  children: React.ReactNode;
}

export const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  return (
    <div>
      <BaseHeader></BaseHeader>
      <main>{children}</main>
    </div>
  );
};
